<template>
    <div class="ivu-vueGauge-div" :style="domStyle">
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>

<style>
</style>

<script>
export default {
    /**
     * 仪表盘组件.
     */
    name : "fvCurve",
    props : ["primitives","fvSystemApi","parentObject"],
    created : function(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.oldTime="";
        //测试代码防止程序崩溃
        // this.gaugeName = "表盘定制";
        // this.signValue = [30,80,150];//设置为量程的区间值
        // this.rangeMin = 0;
        // this.rangeMax = 150;
        // this.signColor = ['#C23531','#63869e','#91c7a1'];
        // this.leavePosition = 4;
        // this.unit = "%";
        // this.scale = false;

        //如果不添加点的话，保证程序不崩溃
        if(this.store == null){
            this.store = []; 
        }
        
        //记录临时时间
        this.leavePosition = this.leavePosition == "" || this.leavePosition == null || this.leavePosition == undefined ? 0 : this.leavePosition;
        var now = new Date();
        this.tempDataTime = now.getTime();
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
  
        
    },
    mounted : function(){
        this.initOption();    //创建仪表盘（无数据）
    },
    data : function(){
        return {
            //组件名称
            name : "newCommunication",
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在vueCreated(创建完毕，挂载前)函数中初始化
            domStyle : {}
            
        }
    },
    methods : {
        /*
            参数：src ：外部属性（对象）
            作用：混淆属性
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
            if(this.isDraw == false) return;
            this.revoeLine();
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        //初始化表盘
        initOption(){
            /**
             * 计算用户输入的值， 换算成0-1区间的小数 
            */
            var signValue1 =  (parseFloat(this.signValue[0]) - parseFloat(this.rangeMin)) / (parseFloat(this.rangeMax)-parseFloat(this.rangeMin));
            var signValue2 =  (parseFloat(this.signValue[1]) - parseFloat(this.rangeMin)) / (parseFloat(this.rangeMax)-parseFloat(this.rangeMin));
            var signValue3 =  (parseFloat(this.signValue[2]) - parseFloat(this.rangeMin)) / (parseFloat(this.rangeMax)-parseFloat(this.rangeMin));
            if(signValue3<1){
                var signArr = [
                    [signValue1,this.signColor[0]],
                    [signValue2,this.signColor[1]],
                    [signValue3,this.signColor[2]],
                    [1,"#fff"]
                ]
            }else{
                var signArr = [
                    [signValue1,this.signColor[0]],
                    [signValue2,this.signColor[1]],
                    [signValue3,this.signColor[2]]
                ]
            }
            /**
             * 计算量程的具体区间步长 this.rangeLenght
             * Math.abs()函数为负数转正数
             * 判断 起始值 是否为负数
             */
            if(parseFloat(this.rangeMin) < 0 && parseFloat(this.rangeMax) > 0 ){
                this.rangeLenght = Math.abs(parseFloat(this.rangeMin))+Math.abs(parseFloat(this.rangeMax));
            }else if(parseFloat(this.rangeMin) > 0 || parseFloat(this.rangeMin) == 0){
                this.rangeLenght = Math.abs(parseFloat(this.rangeMax)) - Math.abs(parseFloat(this.rangeMin));
            }else if(parseFloat(this.rangeMin) < 0&& parseFloat(this.rangeMax) < 0){
                this.rangeLenght = Math.abs(parseFloat(this.rangeMin)) - Math.abs(parseFloat(this.rangeMax));
            }
            /**
             * 计算区间步长小于等于10的情况
             */
            if(this.rangeLenght <= 10){
                this.rangeLenght= this.rangeLenght * 10;
            }
            this.option = {
                backgroundColor:this.backgroundColor,//背景色
                tooltip : {
                    formatter: "{b} : {c}"+this.unit
                },
                //标题
                title:{
                    text: this.gaugeName,
                    textStyle :{
                       color: this.labelColor,
                       fontSize:"auto"
                    },
                    x:'center'
                },
                series: [{
                    type: "gauge",
                    startAngle: 220,//结束的角度
                    endAngle: -40,//开始的角度，是逆时针
                    min: this.rangeMin,//最小量程
                    max: this.rangeMax,//最大量程
                    radius: "98%",
                    center: ["50%", "62%"],
                    //动态添加弧度分割份数
                    splitNumber:this.rangeLenght,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            width: 15,//设置表盘的弧度宽度
                            shadowBlur: 0,
                            color: signArr//区间颜色 值为0-1
                                
                        }
                    },
                    //设置指针长度和宽度
                    pointer:{
                        width:2,
                        length:"80%"
                    },
                    //设置表盘刻度值
                    axisLabel:{
                        fontSize:"auto",
                        color:"#000",
                        //distance: -1,//表盘刻度值偏移
                        /**
                         * 特定返回区间值
                         * v 为分割的值如：100份  v=1-100
                         */
                        formatter:function(v){
                            //设置起始值
                            if(v == parseFloat(this.rangeMin)){
                                return this.rangeMin;
                            }
                            if(v == parseFloat(this.signValue[0])){
                                return this.signValue[0];
                            }
                            if(v == parseFloat(this.signValue[1])){
                                return this.signValue[1];
                            }
                            if(v == parseFloat(this.signValue[2])){
                               return this.signValue[2];
                            }
                            if(v == parseFloat(this.rangeMax)){
                               return this.rangeMax;
                            }
                        }.bind(this)
                    },
                    // 坐标轴小标记
                    axisTick: { 
                        //动态设置
                        show: this.scale, // 属性show控制显示与否，默认不显示
                        splitNumber: 2, // 每份split细分多少段
                        length: 6, // 属性length控制线长
                        lineStyle: { // 属性lineStyle控制线条样式
                            color: '#fff',
                            width: 1,
                            type: 'solid'
                        }
                    },
                    // 设置分隔线
                    splitLine: { 
                        //动态设置 
                        show: this.scale,         
                        length: 15,        // 属性length控制线长
                        lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                            color: '#fff',
                            width: 1
                        }
                    },
                    itemStyle: {
                        normal: {
                            shadowBlur: 0
                        }
                    },
                    //设置表盘显示值
                    detail: {
                        formatter:'{value}' + this.unit,//显示值
                        fontSize:12,//设置动态值大小
                        offsetCenter: [0, '65%']
                    },
                    //表盘标题
                    // title: { 
                    //     fontSize: "auto",
                    //     color: this.labelColor, //动态设置标题颜色
                    //     offsetCenter: [0, '-100%'] //设置标题位置
                    //   },
                    //数据
                    data: [{
                        value:parseFloat(this.rangeMin) , //指针值
                        //name: this.gaugeName
                    }]
                }]
            };
            
            this.chart = document.createElement("div");
            this.chart.style.width  = this.width.toString() + "px";
            this.chart.style.height = this.height.toString() + "px";
            this.chart.style.position = "absolute";
            this.chart.style.zIndex = 9999;
            this.$el.title="";
            this.$el.appendChild(this.chart);
            this.curve = this.$echarts.init(this.chart);
            this.showCurve();
        },
        //显示表盘
        showCurve(){
            this.curve.setOption(this.option,true);
            this.curve.cycle = 0;
            this.curve.resize();
        },
        reDraw(scaleObj){
            if(this.fontSize){
                this.$el.style.fontSize = parseInt((12 * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px"; 
            }
            this.$el.style.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.$el.style.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.$el.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.$el.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
            this.chart.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            this.chart.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.curve.resize();
        },
        
        revoeLine(){
            /**防止没有数据崩溃 */
            if(this.dbVar){
                var temp = this.dbVar[0]+".PV";
                var listNumb = this.fvSystemApi.getReal(temp.split("$").join(""));
                //Math.floor取整   Math.pow 10的n次方
                var value = Math.floor(listNumb.PV * Math.pow(10,this.leavePosition)) / Math.pow(10,this.leavePosition);
                this.option.series[0].data[0].value = value;
            }else{
               this.option.series[0].data[0].value = parseFloat(this.rangeMin);
            }
            this.curve.setOption(this.option, true); 
        },
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/primitives/fvGauge/fvGauge.vue